import mrpHeadingStyle from '../mrp/heading';

export default {
  ...mrpHeadingStyle,
  loyaltyFontStyle: {
    fontWeight: 700,
    fontSize: '26px',
    lineHeight: '32.5px',
    'screen-large': {
      fontSize: '34px',
      lineHeight: '42.5px'
    }
  },
  paragraphFontStyle: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px'
  }
}
